module.exports = __webpack_public_path__ + "img/ECamelRiders64_ua.4a1454a2.webp";